<template>
    <ProjectDetails v-if="!isMobileScreen" class="side-panel" />
    <div v-else class="bottom-panel">
        <VJoyBottomSheet ref="projectSummaryBottomSheet">
            <template #bottom-sheet-content>
                <ProjectDetails />
                <BottomSheetButton
                    :label="t('projectclient.projectinformation.price.amount.incltax')"
                    :value="handleCurrency(projectInformation.lot.invoiceDetails.totalIncludingTaxes, projectInformation?.contract?.currency, locale)"
                    :open="true"
                    @click="closeBottomSheet"
                />
            </template>
        </VJoyBottomSheet>

        <BottomSheetButton
            :label="t('projectclient.projectinformation.price.amount.incltax')"
            :value="handleCurrency(projectInformation.lot.invoiceDetails.totalIncludingTaxes, projectInformation?.contract?.currency, locale)"
            @click="openBottomSheet"
        />
    </div>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {useScreenSizeStore} from '@common/stores';
    import {handleCurrency} from '@common/utils';
    import {storeToRefs} from 'pinia';
    import {useTranslation, useLocale} from '#imports';
    import {VJoyBottomSheet} from '@maltjoy/core-vue';
    import type {ProjectInformationResource} from '@api';
    import BottomSheetButton from './BottomSheetButton.vue';
    import ProjectDetails from './ProjectDetails.vue';

    const props = defineProps<{
        projectInformation: ProjectInformationResource;
    }>();

    const {t} = useTranslation();

    const {locale} = useLocale();

    const screenSizeStore = useScreenSizeStore();
    const {isMobileScreen} = storeToRefs(screenSizeStore);

    // handle hide side panel on smaller screens
    const projectSummaryBottomSheet = useTemplateRef('projectSummaryBottomSheet');

    function openBottomSheet() {
        projectSummaryBottomSheet.value?.show();
    }
    function closeBottomSheet() {
        projectSummaryBottomSheet.value?.hide();
    }
</script>

<style lang="scss" scoped>
    .side-panel {
        flex: 4;
        max-width: 320px;
        height: fit-content;
    }

    .bottom-panel {
        margin-top: var(--joy-core-spacing-8);

        :deep(.joy-panel) {
            border: none;
            padding: 0;
        }
    }
</style>
